// extracted by mini-css-extract-plugin
export default {"category":"Category_category__eXG7W","category_container":"Category_category_container__SQqhm","variantSmall":"Category_variantSmall__wO4eT"};